export default __webpack_public_path__ + "static/media/abstracto31440.2fedddaf.jpg";